import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { OapBadge, EkoBadge } from "@/components/Badges";
import { fmtDate, pad, rupiah } from "@/lib/api";

const ROWS = [
  ["NIK", "nik"], ["No. KK", "no_kk"], ["Jenis Kelamin", "jenis_kelamin"], ["Tempat Lahir", "tempat_lahir"],
  ["Golongan Darah", "golongan_darah"], ["Agama", "agama"], ["Status Perkawinan", "status_perkawinan"],
  ["Hubungan Keluarga", "shdk"], ["Pendidikan", "pendidikan"], ["Pekerjaan", "pekerjaan"], ["Kewarganegaraan", "kewarganegaraan"],
  ["Suku", "suku"], ["Nama Ayah", "nama_ayah"], ["Nama Ibu", "nama_ibu"], ["Alamat", "alamat"], ["RW", "rw"],
  ["Disabilitas", "disabilitas"], ["No. HP", "no_hp"], ["Status", "status"],
];

export const WargaDetail = ({ w, onOpenChange }) => (
  <Dialog open={Boolean(w)} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="warga-detail-dialog">
      {w && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">{w.nama}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-wrap gap-2">
            <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-900 text-white">RT {pad(w.rt)}</span>
            <OapBadge v={w.status_oap} />
            <EkoBadge v={w.status_ekonomi} />
            <span className="text-[11px] px-2 py-0.5 rounded-full border">{w.kelompok_usia} · {w.usia} th</span>
          </div>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mt-4 text-sm">
            <Item k="Tanggal Lahir" v={fmtDate(w.tanggal_lahir)} />
            <Item k="Penghasilan/Bulan" v={rupiah(w.penghasilan)} />
            <Item k="Pendapatan per Kapita KK" v={rupiah(w.pendapatan_per_kapita)} />
            {ROWS.map(([k, f]) => <Item key={f} k={k} v={w[f]} mono={f === "nik" || f === "no_kk"} />)}
          </dl>
        </>
      )}
    </DialogContent>
  </Dialog>
);

const Item = ({ k, v, mono }) => (
  <div className="border-b pb-2">
    <dt className="text-[11px] uppercase tracking-wide text-slate-500">{k}</dt>
    <dd className={`mt-0.5 text-slate-900 ${mono ? "font-mono" : ""}`}>{v || "-"}</dd>
  </div>
);
